// "Your deals" — the whole app for a deal guest (backend app/deal_guest.py).
// Lists the deals whose Deal team holds the signed-in guest (GET
// /api/guest/deals) and opens the regular deal page. Everything else in the
// CRM is refused by the server; app.jsx hides the shell around it.

const GuestDealsView = ({ setDealId, activeUser }) => {
  // Phone: the same list, sized for a finger — the pills drop under the name
  // instead of squeezing it, and no hover tint gets stuck after a tap.
  const phone = !!window.useDevice().phone;
  const [deals, setDeals] = React.useState(null);   // null = loading
  const [error, setError] = React.useState(null);
  React.useEffect(() => {
    let alive = true;
    window.AtlasApi.guestDeals()
      .then((r) => { if (alive) setDeals((r && r.items) || []); })
      .catch((e) => { if (alive) { setDeals([]); setError(e.message || 'Could not load your deals'); } });
    return () => { alive = false; };
  }, []);
  const hues = window.STAGE_DOT_HUE || {};

  return (
    <div style={{ height: '100%', overflow: 'auto', background: 'var(--surface-2)' }}>
      <header style={{ padding: '14px 16px 12px', background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
        <h1 style={{ fontSize: phone ? 22 : 19, fontWeight: 600, color: 'var(--text)' }}>Your deals</h1>
      </header>
      <div style={{ padding: 16, maxWidth: 880, ...(phone ? { paddingBottom: 'calc(16px + var(--sab, 0px))' } : null) }}>
        {deals === null && <div style={{ fontSize: phone ? 15 : 12, color: 'var(--text-3)' }}>Loading…</div>}
        {error && <div style={{ fontSize: phone ? 15 : 12.5, color: 'var(--rose-fg)', marginBottom: 10 }}>{error}</div>}
        {deals && deals.length === 0 && !error && (
          <div style={{ fontSize: phone ? 15 : 12.5, color: 'var(--text-3)', lineHeight: 1.5 }}>
            You're not on any deal right now. An admin adds you from the deal's Deal team.
          </div>
        )}
        {deals && deals.length > 0 && (
          <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 9, overflow: 'hidden' }}>
            {deals.map((d, i) => phone ? (
              <button key={d.id} onClick={() => setDealId(d.id)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left', minHeight: 64,
                  padding: '12px 14px', border: 'none', background: 'transparent', cursor: 'pointer',
                  borderTop: i === 0 ? 'none' : '1px solid var(--border)', color: 'var(--text)',
                  WebkitTapHighlightColor: 'transparent',
                }}>
                <Logo name={d.company_name || d.name} size={36} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 15.5, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.name}</div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 4 }}>
                    {d.stage_name && <Pill hue={hues[d.stage_slug] || 'slate'} dot sz="sm">{d.stage_name}</Pill>}
                    {d.on_hold && <Pill hue="amber" sz="sm">On hold</Pill>}
                    {d.exited && <Pill hue="rose" sz="sm">Exited</Pill>}
                  </div>
                  <div style={{ fontSize: 13, color: 'var(--text-3)', marginTop: 4, lineHeight: 1.4 }}>
                    {[d.company_name && d.company_name !== d.name ? d.company_name : null, d.dealmaker_name,
                      d.estimated_close_date && `Est. close ${fmtDate(d.estimated_close_date)}`].filter(Boolean).join(' · ')}
                  </div>
                </div>
                <Icon.ChevronR size={14} color="var(--text-4)" />
              </button>
            ) : (
              <button key={d.id} onClick={() => setDealId(d.id)}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--surface-hover)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left',
                  padding: '12px 14px', border: 'none', background: 'transparent', cursor: 'pointer',
                  borderTop: i === 0 ? 'none' : '1px solid var(--border)', color: 'var(--text)',
                }}>
                <Logo name={d.company_name || d.name} size={28} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.name}</div>
                  <div style={{ fontSize: 11.5, color: 'var(--text-3)', marginTop: 2 }}>
                    {[d.company_name, d.dealmaker_name && `Dealmaker · ${d.dealmaker_name}`,
                      d.estimated_close_date && `Est. close ${fmtDate(d.estimated_close_date)}`].filter(Boolean).join('  ·  ')}
                  </div>
                </div>
                {d.stage_name && <Pill hue={hues[d.stage_slug] || 'slate'} dot sz="sm">{d.stage_name}</Pill>}
                {d.on_hold && <Pill hue="amber" sz="sm">On hold</Pill>}
                {d.exited && <Pill hue="rose" sz="sm">Exited</Pill>}
                <Icon.ChevronR size={12} color="var(--text-4)" />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

window.GuestDealsView = GuestDealsView;
